import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const agentSelectionWrapper: ThemedFunctor = () => css`
  position: relative;
`;

export const agentRemoveAction: ThemedFunctor = () => css`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
`;
